import styled from "styled-components";

export const Wrapper = styled.div`
  max-width: 100%;
  padding: 32px;
  margin: 32px auto;
  text-align: center;
`;
